import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { TeamLineupsSponsor } from './TeamLineupsSponsor';

export const TeamLineupsSponsorProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <TeamLineupsSponsor {...data} />
        </Provider>
    );
};

TeamLineupsSponsorProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
